import { theme } from '../globalStyle/global-styles';
import styled from 'styled-components';

export const BreadcrumbsWrapper = styled.div`
  a {
    border: 1px solid ${theme.colours.white};
    padding: 8px;
    border-radius: 8px;
    background-color: ${theme.colours.white};
    color: ${theme.colours.silverChalice};
    @media (max-width: 1025px) {
      font-size: 14px;
    }
    @media (max-width: 425px) {
      font-size: 3.2vw;
    }
  }
  .mantine-Breadcrumbs-separator {
    margin: 3px;
    svg {
      color: ${theme.colours.silverChalice};
    }
  }
`;
